import styled, { css } from 'styled-components'

export const ConversationOrderSummaryValueStyled = styled.span<{
  $isBold?: boolean
  $isSecondary?: boolean
  $isTruncated?: boolean
}>`
  display: block;
  color: ${(props) =>
    props.$isSecondary
      ? props.theme.colors.text.secondary
      : props.theme.colors.text.primary};
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  font-weight: ${(props) =>
    props.$isBold
      ? props.theme.fontWeights.semibold
      : props.theme.fontWeights.normal};
  line-height: ${(props) => props.theme.typography.pxToRem(24)};

  ${(props) =>
    props.$isTruncated &&
    css`
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    `}
`
